.results {
  padding: 4px 10px 6px 10px;
  color: #78767b;
  transform: translateY(0);
  transition: 0.5s ease all;

  &.isHidden {
    padding-top: 0;
    padding-bottom: 0;
    height: 0;
    // go down while collapse appears to go up
    transform: translateY(100%);
  }
}
